import { render } from "./VoiceAction.vue?vue&type=template&id=6cc7ece4&scoped=true"
import script from "./VoiceAction.vue?vue&type=script&lang=js"
export * from "./VoiceAction.vue?vue&type=script&lang=js"

import "./VoiceAction.vue?vue&type=style&index=0&id=6cc7ece4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc7ece4"]])

export default __exports__